<template>
  <v-container fill-height justify-content-start :class="{'pa-2': $vuetify.breakpoint.xsOnly}" class="app-section-width">
    <v-layout column>
      <v-toolbar color="white" flat>
        <v-btn icon light @click="exit()">
          <v-icon color="grey darken-2">mdi-arrow-left</v-icon>
        </v-btn>
        <v-toolbar-title class="grey--text text--darken-4 pa-0">
          {{ $t('headers.guest_checkin') }}
          <span class="guest-name" v-if="guestName !== null">{{ guestName }}</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-flex class="app-scroll-section">
        <v-stepper v-model="step" vertical height="200">

          <v-stepper-step step="1" :complete="step > 1" color="primary darken-1">{{ $t('headers.data_registry') }}</v-stepper-step>

          <v-stepper-content step="1">
            <GuestCheckinStep1 ref="step1" @onIsCompletedChange="onIsCompletedChangeStep1" :id="id" />
          </v-stepper-content>

          <v-stepper-step step="2" :complete="step > 2" color="primary darken-1">{{ $t('headers.data_validation') }}</v-stepper-step>

          <v-stepper-content step="2">
            <GuestCheckinStep2 ref="step2" :pendingVerification="pendingDocumentVerification" @onIsCompletedChange="onIsCompletedChangeStep2" @onSuccessChange="onSuccessStep2" />
          </v-stepper-content>

          <v-stepper-step v-if="contactDataEnabled" step="3" :complete="step > 3" color="primary darken-1">{{ $t('headers.contact_data') }}</v-stepper-step>

          <v-stepper-content step="3">
            <GuestCheckinStep3 ref="step3" @onIsCompletedChange="onIsCompletedChangeStep3" />
          </v-stepper-content>

          <v-stepper-step :step="contactDataEnabled ? '4' : '3'" :complete="step > 4" color="primary darken-1">{{ $t('headers.accept_terms_and_conditions') }}</v-stepper-step>

          <v-stepper-content step="4">
            <GuestCheckinStep4 ref="step4" @onIsCompletedChange="onIsCompletedChangeStep4" />
          </v-stepper-content>
        </v-stepper>
      </v-flex>

      <div class="stepper-actions">
        <v-btn outlined @click="back()" :disabled="!backActive">{{ $t('actions.back') }}</v-btn>
        <v-btn outlined :loading="loadingNextStep" @click="next()" :disabled="!nextActive">{{ $t('actions.next') }}</v-btn>
      </div>

    </v-layout>

  </v-container>
</template>

<script>
import {
  getGuestName,
  getGuestLastName,
} from '@/lib/helpers/GuestName'
import { mapGetters } from 'vuex'
import routeNames from '@/router/routes'
import router from '@/router'
export default {
  data () {
    return {
      contentHeight: 0,
      step: 1,
      isCompleted: {
        step1: false,
        step2: false,
        step3: false,
        step4: false,
      },
      successStep2: false,
      loadingNextStep: false,
      pendingDocumentVerification: false,
    }
  },
  computed: {
    id () {
      return this.$route.params.guestId
    },
    bookingId () {
      return this.$route.params.bookingId
    },
    nextActive () {
      if (this.step === 1) {
        return this.isCompleted.step1
      } else if (this.step === 2) {
        return this.isCompleted.step2
      } else if (this.step === 3) {
        return this.isCompleted.step3
      } else if (this.step === 4) {
        return this.isCompleted.step4
      }

      return false
    },
    backActive () {
      if (this.step === 2) {
        if (this.scannedDocument && this.scannedDocument.status === 'SUCCESS') {
          return false
        } else if (!this.scannedDocument || this.scannedDocument.status === 'FAILED') {
          return true
        }
      } else if (this.step === 3) {
        return true
      } else if (this.step === 4) {
        return true
      }

      return false
    },
    verifiedDocumentData () {
      return this.$store.state.registrationCards.verifiedDocumentData
    },
    scannedDocument () {
      return this.$store.state.registrationCards.scannedDocument
    },
    guest () {
      if (this.$store.state.me.bookings === null) {
        return []
      }

      let id = this.id
      let guest = null
      let guests = this.$store.state.me.bookings.find((b) => { return b.booking.id === this.bookingId }).guests

      guests.forEach((item, i) => {
        if (item.guest.id === id) {
          guest = item
        }
      })

      return guest
    },
    guestName () {
      return `${ getGuestName(this.guest) } ${ getGuestLastName(this.guest) }`
    },
    ...mapGetters({
      contactDataEnabled: 'service/contactDataEnabled',
    }),
  },
  methods: {
    exit () {
      router.push({ name: routeNames.checkin.name })
    },
    async next () {
      this.loadingNextStep = true
      try {
        if (this.step === 1) {
          if (
            this.scannedDocument === null ||
            this.scannedDocument.status === 'FAILED'
          ) {
            if (this.scannedDocument !== null && this.scannedDocument.status === 'SUCCESS') {
              this.$store.state.registrationCards.scannedDocument.status = 'IN_PROGRESS'
            }
            await this.sendDocuments().then(() => {
              var self = this
              this.pendingDocumentVerification = true
              setTimeout(function () { self.isDocumentsProcessed() }, 5000)
            })
          }
        } else if (this.step === 2) {
          await this.postVerifiedData()
        } else if (this.step === 3) {
          await this.postContactData()
        } else if (this.step === 4) {
          await this.postSignature().then(() => {
            this.$store.commit('state/setMessage', { text: this.$t('success.checkin'), color: 'success' })
            this.exit()
          }).catch((error) => {
            throw error
          })
        }
      } catch (error) {
        if (error.status === 403 || error.status === 404) {
          this.$router.push({ name: routeNames.main.name })
          this.$store.commit('state/setMessage', { text: this.$t('error.forbidden'), color: 'error' })
        }
      }

      if (this.step === 2 && !this.contactDataEnabled) {
        this.step += 2
      } else {
        this.step += 1
      }
      this.loadingNextStep = false
    },
    back () {
      if (this.step === 4 && !this.contactDataEnabled) {
        this.step -= 2
      } else {
        this.step -= 1
      }
    },
    onIsCompletedChangeStep1 (value) {
      this.isCompleted.step1 = value
    },
    onIsCompletedChangeStep2 (value) {
      this.isCompleted.step2 = value
      if (!this.contactDataEnabled) {
        this.isCompleted.step3 = value
      }
    },
    onIsCompletedChangeStep3 (value) {
      this.isCompleted.step3 = value
    },
    onIsCompletedChangeStep4 (value) {
      this.isCompleted.step4 = value
    },
    onSuccessStep2 (value) {
      this.successStep2 = value
    },
    sendDocuments () {
      let data = {
        guestId: this.id,
        countryCode: this.$refs.step1.country.id,
        cardType: this.$refs.step1.documentType,
        documentImageFront: this.$refs.step1.documentImageFront,
      }

      if (this.$refs.step1.documentImageBack) {
        data.documentImageBack = this.$refs.step1.documentImageBack
      }

      return this.$store.dispatch('registrationCards/postDocumentScan', data)
    },
    isDocumentsProcessed () {
      this.$store.dispatch('registrationCards/get', { guestId: this.id }).then(() => {
        let status = this.$store.state.registrationCards.scannedDocument.status
        if (status === 'IN_PROGRESS') {
          var self = this
          setTimeout(function () { self.isDocumentsProcessed() }, 5000)
        } else if (status === 'SUCCESS') {
          this.pendingDocumentVerification = false
        } else if (status === 'FAILED') {
          this.step = 1
          this.pendingDocumentVerification = false
        }
      }).catch(() => {})
    },
    postVerifiedData () {
      return this.$store.dispatch('registrationCards/post', { guestId: this.id })
    },
    postContactData () {
      let formValues = this.$refs.step3.formValues
      let fields = Object.keys(formValues)
      let body = {}

      for (var i = 0; i < fields.length; i++) {
        if (formValues[fields[i]].trim() !== '') {
          body[fields[i]] = formValues[fields[i]]
        }
      }

      let data = {
        guestId: this.id,
        body: body,
      }

      return this.$store.dispatch('registrationCards/postContact', data)
    },
    postSignature () {
      const { data } = this.$refs.step4.$refs.signaturePad.saveSignature()
      let checkboxes = []
      let checkboxesKeys = Object.keys(this.$refs.step4.formValues)

      for (var i = 0; i < checkboxesKeys.length; i++) {
        let checkboxValue = this.$refs.step4.formValues[checkboxesKeys[i]]
        let value = checkboxValue === 'true'
        checkboxes.push({ field_name: checkboxesKeys[i], value: value })
      }

      let requestData = {
        guestId: this.id,
        signature: this.b64toBlob(data),
        checkboxes: checkboxes,
      }

      return this.$store.dispatch('registrationCards/postSignature', requestData)
    },
    b64toBlob (dataURI) {
      var byteString = atob(dataURI.split(',')[1])
      var ab = new ArrayBuffer(byteString.length)
      var ia = new Uint8Array(ab)

      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }
      return new Blob([ab], { type: 'image/png' })
    },
  },
  components: {
    GuestCheckinStep1: () => import('@/components/view-components/checkin/GuestCheckinStep1.vue'),
    GuestCheckinStep2: () => import('@/components/view-components/checkin/GuestCheckinStep2.vue'),
    GuestCheckinStep3: () => import('@/components/view-components/checkin/GuestCheckinStep3.vue'),
    GuestCheckinStep4: () => import('@/components/view-components/checkin/GuestCheckinStep4.vue'),
  },
  created () {
    if (this.$store.state.me.bookings === null) {
      this.$store.dispatch('me/getBookings', null, { root: true })
    }
    this.$store.dispatch('registrationCards/get', { guestId: this.id }).then(() => {
      let contactData = this.$store.state.registrationCards.contactData
      let scannedDocument = this.$store.state.registrationCards.scannedDocument
      let verifiedDocumentData = this.$store.state.registrationCards.verifiedDocumentData

      if (contactData != null || (verifiedDocumentData != null && !this.contactDataEnabled)) {
        this.step = 4
      } else if (verifiedDocumentData != null) {
        this.step = 3
      } else if (scannedDocument != null) {
        if (scannedDocument.status === 'IN_PROGRESS') {
          this.step = 2
          var self = this
          setTimeout(function () { self.isDocumentsProcessed() }, 5000)
        } else if (scannedDocument.status === 'FAILED') {
          this.step = 1
        } else {
          this.step = 2
        }
      }
    }).catch(() => {})
  },
  beforeDestroy () {
    this.$store.commit('registrationCards/resetRegistrationCardState')
  },
}
</script>

<style lang="scss">
#content {
  overflow-y: auto;
}

#guest-checkin {
  max-width: 430px !important;
  padding: 0 15px;

  .v-toolbar {
    height: 76px !important;
  }

  .v-toolbar__content {
    padding: 0;
    height: 76px !important;
  }

  .v-toolbar__title {
    .guest-name {
      display: block;
      font-size: 18px;
    }
  }
}

.v-stepper {
  box-shadow: none;
  -webkit-box-shadow: none;

  .v-stepper__step {
    padding-left: 0px;
    padding-right: 0px;
  }
}

.v-stepper--vertical {
  .v-stepper__content {
    padding-top: 8px;
    padding-bottom: 8px;
  }
}

.v-stepper__content {
  margin-left: 10px !important;
  padding-right: 36px !important;
}

.stepper-actions {
  height: 80px;
  padding-top: 22px;

  .v-btn:last-child {
    float: right;
  }
}

@media (min-width: 960px) {
  #guest-checkin {
    padding: 10px;
    max-width: 630px !important;
  }
}

.step {
  padding-bottom: 30px;
}
</style>
